import { ContentTableItem } from "src/components/ContentTable/ContentTable";

export function mapHashtagsToContentTableItems(
	hashtags: AdminHashtag[]
): ContentTableItem[] {
	return [...hashtags]
		.sort((a, b) => a.name.localeCompare(b.name))
		.map((hashtag) => ({
			id: hashtag.uuid,
			name: hashtag.name,
			createdBy: hashtag.createdBy
				? `${hashtag.createdBy.firstName} ${hashtag.createdBy.lastName}`
				: undefined,
			lastUpdated: hashtag.updatedAt ?? hashtag.createdAt,
			isActive: true,
			data: {
				color: hashtag.color,
				isPrivate: hashtag.isPrivate,
				isFavourite: hashtag.isFavourite,
				source: hashtag.source
			}
		}));
}
